module.exports = __webpack_public_path__ + "static/media/user_feedback_1.5ce50e8e.png";